import type { RouteRecordRaw } from "vue-router";

export const publicRoutes: RouteRecordRaw[] = [
  {
    path: "/ui-kit",
    name: "ui-kit",
    component: () => import("@/views/UIKitPage.vue"),
  },
];
